import { Component, Vue } from 'vue-property-decorator'
import SubMenu from '@/components/submenu/index.vue'

@Component({
    components:{ SubMenu }
})
export default class ReviewSettinges extends Vue {

}